import './style.scss'; // Ensure this file contains the updated styles
const OrderSummary = () => {
  return (
    <div className="order-summary-container">
      <h2 className="order-summary-header">Order Summary</h2>
      <div className="order-number">Order #H35584</div>

      <table className="order-summary-table">
        <tbody>
          <tr>
            <td>1</td>
            <td>Regular delegate full registration</td>
            <td className="price">1300 USD</td>
          </tr>
          <tr>
            <td>1</td>
            <td>Reception ticket</td>
            <td className="price">Free</td>
          </tr>
          <tr>
            <td>1</td>
            <td>Banquet ticket</td>
            <td className="price">Free</td>
          </tr>
          <tr className="total-row">
            <td colSpan="2" className="total-label">TOTAL:</td>
            <td className="price total-price">1300 USD</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default OrderSummary;